import {DossierItemType} from "const/DossierItemType"

export default  {

  list: {
    title: "Dossier",
    noData: "Geen dossier items gevonden",

    type: {
      [DossierItemType.invoice]: "Factuur"
    }
  },

  note: {
    title: "Notitie",

    input: {
      subject: "Onderwerp",
    },
  },

  api: {
    dossierNote: {
      id: {
        notNull: "Er is iets verkeerd gegaan, we weten niet welke notitie er verwijderd moet worden",
      },
    },
  },
}
